export class ParametroIntegraXSmsModel {
  id?: number;
  token?: string;
  remetente?: string;
  valorMensagem?: number;
  moedaCusto: 'BRL' | 'USD' | 'EUR' = 'USD';
  usuario?: string;
  senha?: string;
  ativo?: boolean;
}
